import { useEffect, useMemo } from 'react';
import { ethers } from 'ethers';
import { useDispatch, useSelector } from 'react-redux';
import {
    getConnectedAddress,
    getWalletInfo,
    getWeb3Connected,
    setCurrentChainId,
    setHasTriedToConnect,
} from 'store/action';
import {
    useAppKit,
    useAppKitState,
    useAppKitAccount,
    useAppKitProvider,
} from '@reown/appkit/react';
import web3Service from 'util/web3Service';
import { useLocation } from 'react-router-dom';
import { modal } from './index';

export default function Web3WalletModal({
    isOpen,
}) {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const { hasTriedToConnect } = useSelector((state) => state.Trade);
    const { open, close } = useAppKit();
    const { initialized } = useAppKitState();
    const { isConnected, address, caipAddress } = useAppKitAccount();
    const { chainId, chainNamespace } = useMemo(() => caipAddress ?
            { chainId: Number(caipAddress.split(':')[1]), chainNamespace: caipAddress.split(':')[0] } :
            { chainId: undefined, chainNamespace: undefined },
        [caipAddress],
    );
    const { walletProvider } = useAppKitProvider(chainNamespace);

    async function onOpen() {
        if (!isOpen) {
            await open({ view: 'Connect' });
        }
    }

    useEffect(() => {
        dispatch(getWeb3Connected(isConnected));
        const localWalletProvider = walletProvider || modal.getWalletProvider();
        if (isConnected && address && chainId && localWalletProvider) {
            dispatch(getConnectedAddress(address));
            const newChainId = chainId;
            dispatch(setCurrentChainId(newChainId));

            let ethersProvider;

            try {
                ethersProvider = new ethers.providers.Web3Provider(
                    localWalletProvider,
                    newChainId,
                );
                web3Service.setHookValue(ethersProvider);
            } catch (e) {
                console.error(e);
                web3Service.setHookValue(null);
            }

            ethersProvider = new ethers.providers.Web3Provider(localWalletProvider);
            const signer = ethersProvider.getSigner();

            Promise.all([signer.getAddress(), signer.getChainId()]).then(([address, ChainId]) => {
                dispatch(getWalletInfo({
                    walletConnect: signer,
                    network: {
                        chain: { id: ChainId },
                    },
                    accounts: [address],
                    chainId: newChainId || ChainId,
                    netID: newChainId || ChainId,
                    metaMaskAddress: address,
                }));
            });
        } else {
            dispatch(getWalletInfo({}));
        }
    }, [isConnected, address, chainId, walletProvider, dispatch]);

    useEffect(() => {
        if (!initialized || hasTriedToConnect ||
            (!pathname.startsWith('/liquidity') && !pathname.startsWith('/staking'))
        ) return;

        dispatch(setHasTriedToConnect(true));
        if (!isConnected) onOpen();

        return () => {
            close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected, initialized, hasTriedToConnect, pathname]);
}
